import { Container, Row, Col } from "react-bootstrap";
import Nav from "../../../components/Navbar";
import Footer from "../../Footer";
const PrivacyPolicy = () => {
  const start = "Форма запроса программного обеспечения и QR-кода лицензии";

  return (
    <>
      <Nav />

      <Container className="mh-100">
        <Row className="px-3 px-lg-0 pt-3 pt-lg-5">
          <Col xs="12" className="text-center my-5">
            <h1>ПОЛИТИКА ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ ПОЛЬЗОВАТЕЛЕЙ</h1>
          </Col>
          <Col>
            <strong>
              <p className="text-center ">
                ПОЛИТИКА ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ ПОЛЬЗОВАТЕЛЕЙ САЙТА АО
                «СИГНАЛ-КОМ»
              </p>
            </strong>

            <strong>1. Общие положения</strong>
            <p>
              1.1. Настоящая Политика обработки персональных данных
              пользователей сайтов АО «СИГНАЛ-КОМ» (далее — Политика)
              предназначена для ознакомления пользователей сайта АО «СИГНАЛ-КОМ»
              (далее — Оператор) с основами обработки и защиты персональных
              данных, которые могут быть переданы Пользователем при помощи
              сайтов Оператора.
              <br />
              1.2. Политика разработана в соответствии с требованиями
              Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных»
              и является публичным, общедоступным документом. Действующая
              редакция Политики на бумажном носителе хранится по местонахождению
              Оператора по адресу: г. Москва, ул. Угрешская, дом 2, строение 15,
              этаж 3, офис СИГНАЛ-КОМ. Электронная версия действующей редакции
              Политики размещена на сайте Оператора в сети интернет: 
              <a href="https://smarttoken.pro" target="_blank" > https://smarttoken.pro</a>.
            </p>
            <strong>2. Основные понятия, используемые в Политике</strong>
            <p>
              2.1. персональные данные — любая информация, относящаяся к прямо
              или косвенно определённому или определяемому физическому лицу
              (субъекту персональных данных);
              <br />
              2.2. оператор персональных данных (Оператор) — АО «СИГНАЛ-КОМ»,
              осуществляющий обработку персональных данных Пользователей;
              <br />
              2.3. агент — юридическое лицо или индивидуальный предприниматель,
              совершающие операции или выполняющие действия для Оператора по
              обработке персональных данных на договорной основе;
              <br />
              2.4. пользователь — субъект персональных данных, являющийся
              пользователем сайтов Оператора или сайтов агентов Оператора;
              <br />
              2.5. сайт — веб-сайт Оператора, расположенный в сети интернет по
              адресу: <a href="https://smarttoken.pro" target="_blank" > https://smarttoken.pro</a> — и его поддоменах, а также
              веб-сайты агентов Оператора;
              <br />
              2.6. обработка персональных данных — любое действие (операция) или
              совокупность действий (операций) с персональными данными,
              совершаемых с использованием средств автоматизации или без их
              использования. Обработка персональных данных включает в себя, в
              том числе: сбор, запись, систематизацию, накопление, хранение,
              уточнение (обновление, изменение), извлечение, использование,
              передачу (распространение, предоставление, доступ), обезличивание,
              блокирование, удаление, уничтожение;
              <br />
              2.7. автоматизированная обработка персональных данных — обработка
              персональных данных с помощью средств вычислительной техники;
              <br />
              2.8. распространение персональных данных — действия, направленные
              на раскрытие персональных данных неопределённому кругу лиц;
              <br />
              2.9. предоставление персональных данных — действия, направленные
              на раскрытие персональных данных определённому лицу или
              определённому кругу лиц;
              <br />
              2.10. блокирование персональных данных — временное прекращение
              обработки персональных данных (за исключением случаев, если
              обработка необходима для уточнения персональных данных);
              <br />
              2.11. уничтожение персональных данных — действия, в результате
              которых становится невозможным восстановить содержание
              персональных данных в информационной системе персональных данных и
              (или) в результате которых уничтожаются материальные носители
              персональных данных;
              <br />
              2.12. обезличивание персональных данных — действия, в результате
              которых становится невозможным без использования дополнительной
              информации определить принадлежность персональных данных
              конкретному субъекту персональных данных;
              <br />
              2.13. информационная система персональных данных — совокупность
              содержащихся в базах данных персональных данных и обеспечивающих
              их обработку информационных технологий и технических средств;
              <br />
              2.14. трансграничная передача персональных данных — передача
              персональных данных на территорию иностранного государства органу
              власти иностранного государства, иностранному физическому лицу или
              иностранному юридическому лицу;
              <br />
              2.15. конфиденциальность персональных данных — обязательное для
              выполнения Оператором и иными лицами, получившими доступ к
              персональным данным, требование не раскрывать третьим лицам и не
              распространять персональные данные без согласия субъекта
              персональных данных, если иное не предусмотрено Федеральным
              законом от 27.07.2006 № 152-ФЗ «О персональных данных».
              <br />
              2.16. Оператор при осуществлении обработки персональных данных
              берет на себя следующие обязательства:
              <br />
              2.17. осуществлять сбор персональных данных в порядке,
              установленном Федеральным законом от 27.07.2006 № 152-ФЗ «О
              персональных данных»;
              <br />
              2.18. принимать меры, необходимые и достаточные для обеспечения
              выполнения обязанностей, предусмотренных Федеральным законом от
              27.07.2006 № 152-ФЗ «О персональных данных» и принятыми в
              соответствии с ним нормативными правовыми актами;
              <br />
              2.19. сообщать в установленном порядке Пользователям или их
              представителям информацию об обработке персональных данных,
              относящихся к соответствующим Пользователям, предоставлять
              возможность ознакомления с этими персональными данными при
              обращении и (или) поступлении запросов указанных Пользователей или
              их представителей, если иное не установлено законодательством
              Российской Федерации;
              <br />
              2.20. предоставить документы и локальные акты и (или) иным образом
              подтвердить принятие мер, направленных на обеспечение выполнения
              Оператором своих обязанностей в отношении обработки персональных
              данных, по запросу уполномоченного органа по защите прав субъектов
              персональных данных;
              <br />
              2.21. принимать правовые, организационные и технические меры для
              защиты персональных данных от неправомерного или случайного
              доступа к ним, уничтожения, изменения, блокирования, копирования,
              предоставления, распространения персональных данных, а также иных
              неправомерных действий в отношении персональных данных;
              <br />
              2.22. устранять нарушения законодательства, допущенные при
              обработке персональных данных, по уточнению, блокированию и
              уничтожению персональных данных;
              <br />
              2.23. уведомлять уполномоченный орган по защите прав субъектов
              персональных данных о своём намерении осуществлять обработку
              персональных данных в порядке, установленном Федеральным законом
              от 27.07.2006 № 152-ФЗ «О персональных данных»;
              <br />
              2.24. назначать лицо, ответственное за организацию обработки
              персональных данных; совершать иные действия, предусмотренные
              законодательством Российской Федерации в области обработки
              персональных данных.
            </p>
            <strong>3. Основные права и обязанности пользователя </strong>
            <p>
              3.1. Пользователь имеет право:
              <br />— получать сведения, касающиеся обработки его персональных
              данных Оператором, в порядке и объёме, предусмотренном Федеральным
              законом от 27.07.2006 № 152-ФЗ «О персональных данных»;
              <br />— требовать от Оператора уточнения его персональных данных,
              их блокирования или уничтожения в случае, если персональные данные
              являются неполными, устаревшими, неточными, незаконно полученными
              или не являются необходимыми для заявленной цели обработки;
              <br />— принимать предусмотренные законом меры по защите своих
              прав;
              <br />— отозвать согласие на обработку персональных данных; в
              случае отзыва Пользователем согласия на обработку персональных
              данных Оператор вправе продолжить их обработку без согласия
              Пользователя при наличии оснований, указанных в пунктах 2 — 11
              части 1 статьи 6, части 2 статьи 10 и части 2 статьи 11
              Федерального закона от 27.07.2006 № 152-ФЗ «О персональных
              данных»;
              <br />— требовать от Оператора немедленного прекращения обработки
              его персональных данных в целях продвижения товаров, работ, услуг
              на рынке;
              <br />— обжаловать действия или бездействие Оператора в
              уполномоченный орган по защите прав субъектов персональных данных
              или в судебном порядке;
              <br />— защищать свои права и законные интересы, в том числе на
              возмещение убытков и (или) компенсацию морального вреда в судебном
              порядке.
              <br /> 3.2. Пользователи обязаны:
              <br />— предоставлять Оператору достоверные данные о себе;
              <br /> — сообщать Оператору об уточнении (обновлении, изменении)
              своих персональных данных.
              <br /> 3.3. Лица, передавшие Оператору недостоверные сведения о
              себе, либо сведения о другом субъекте персональных данных без
              согласия последнего, несут ответственность в соответствии с
              законодательством РФ.
            </p>
            <strong> 4. Цели сбора и обработки персональных данных</strong>
            <p>
              4.1. Персональные данные Пользователей на сайте  
              <a href="https://smarttoken.pro" target="_blank" > https://smarttoken.pro</a>, его поддоменах, а также веб-сайтах агентов
              Оператора обрабатываются Оператором для достижения следующих
              целей:
              <br /> 4.1.1. Регистрация на сайтах Оператора.
              <br />
              4.1.2. Реализация обратной связи и осуществление взаимодействия с
              Оператором.
              <br />
              4.1.3. Подписка на рассылку информационных и рекламных материалов
              Оператора.
              <br />
              4.1.4. Подготовка к заключению договора (формирование заявки на
              оказание услуги, выставление счёта, регистрация в личном кабинете
              и др).
              <br />
              4.1.5. Оказание Оператором услуг по технической поддержке
              Пользователей.
              <br />
              4.2. Обработка персональных данных, несовместимая с заявленными
              целями обработки, Оператором не допускается.
            </p>
            <strong>5. Правовые основания обработки персональных данных</strong>
            <p>
              5.1. Правовыми основаниями для обработки персональных данных
              Пользователей Оператором являются:
              <br /> — Конституция Российской Федерации.
              <br /> — Гражданский кодекс Российской Федерации.
              <br />— Налоговый кодекс Российской Федерации.
              <br /> — Федеральный закон от 27.07.2006 № 149-ФЗ «Об информации,
              информационных технологиях и о защите информации».
              <br /> — Федеральный закон от 06.04.2011 № 63-ФЗ «Об электронной
              подписи».
              <br /> — Приказ Министерства культуры и массовых коммуникаций
              Российской Федерации от 31.07.2007 № 1182 «Об утверждении Перечня
              типовых архивных документов, образующихся в научно-технической и
              производственной деятельности организаций, с указанием сроков
              хранения».
              <br /> — Приказ Министерства культуры Российской Федерации от
              25.08.2010 № 558 «Об утверждении Перечня типовых управленческих
              архивных документов, образующихся в процессе деятельности
              государственных органов, органов местного самоуправления и
              организаций, с указанием сроков хранения».
              <br /> — Приказ ФСБ РФ от 27.12.2011 № 795 «Об утверждении
              требований к форме квалифицированного сертификата ключа проверки
              электронной подписи».
              <br /> — Приказ Минкомсвязи России от 13.04.2012 № 107 «Об
              утверждении Положения о федеральной государственной информационной
              системе „Единая система идентификации и аутентификации в
              инфраструктуре, обеспечивающей информационно-технологическое
              взаимодействие информационных систем, используемых для
              предоставления государственных и муниципальных услуг в электронной
              форме”».
              <br />— Устав АО «СИГНАЛ-КОМ».
              <br />— Регламент Удостоверяющего центра АО «СИГНАЛ-КОМ».
              <br />— Регламент Удостоверяющего центра АО «ИнфоТеКC».
              <br /> — Соглашение о регистрирующем уполномоченном органе в
              соответствии со стандартом ГОСТ Р ИСО/МЭК 9834-1-2009 между
              Оператором и Федеральным агентством по техническому регулированию
              и метрологии (Росстандарт).
              <br /> — Лицензии, сертификаты и другие документы, подтверждающие
              право осуществления деятельности Оператора.
              <br /> — Локальные правовые акты Оператора по вопросам обработки и
              обеспечению безопасности персональных данных.
              <br /> — Договоры, заключаемые между Оператором и Пользователем.
              <br /> — Согласие Пользователя.
            </p>
            <strong>
              {" "}
              6. Объём и категории обрабатываемых персональных данных
              Пользователей
            </strong>
            <p>
              6.1. Оператор обрабатывает следующие категории персональных данных
              Пользователей на сайте <a href="https://smarttoken.pro" target="_blank" > https://smarttoken.pro</a>, его поддоменах, а
              также веб-сайтах агентов Оператора:
              <br /> — фамилия, имя, отчество;
              <br /> — СНИЛС;
              <br />— ИНН;
              <br />— ОГРНИП;
              <br />— адрес места жительства;
              <br />— наименование занимаемой должности и место работы;
              <br /> — контактный телефон;
              <br /> — адрес электронной почты;
              <br />
              6.2. Обработка биометрических персональных данных и специальных
              категорий персональных данных, касающихся расовой, национальной
              принадлежности, политических взглядов, религиозных или философских
              убеждений, состояния здоровья, интимной жизни, на сайтах Оператора
              не осуществляется.
            </p>
            <strong>
              7. Общий порядок и условия обработки персональных данных
            </strong>
            <p>
              7.1. Обработка персональных данных с использованием сайтов
              Оператора осуществляется с согласия Пользователя на обработку его
              персональных данных.
              <br /> 7.2. Пользователь выражает свое согласие на обработку
              персональных данных, заполняя поля форм на сайтах Оператора,
              предназначенных для ввода персональных данных, и устанавливая
              «галочку» в соответствующем поле:
              <br /> — ☐ Я даю свое согласие на обработку и использование моих
              персональных данных;
              <br /> — или подтверждая действием нажатия на кнопку отправки
              данных.
              <br /> 7.3. Оператор осуществляет следующие действия с
              персональными данными: сбор, запись, систематизация, накопление,
              хранение, уточнение (обновление, изменение), извлечение,
              использование, передача (распространение, предоставление, доступ),
              блокирование, удаление, уничтожение.
              <br /> 7.4. Оператор обеспечивает запись, систематизацию,
              накопление, хранение, уточнение (обновление, изменение),
              извлечение персональных данных с использованием баз данных,
              находящихся на территории Российской Федерации, в соответствии
              Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных
              данных».
              <br /> 7.5. Обработка персональных данных осуществляется
              Оператором следующими способами:
              <br /> — автоматизированная обработка персональных данных с
              передачей полученной информации по защищенным каналам
              информационно-телекоммуникационных сетей или без таковой;
              <br /> — неавтоматизированная обработка персональных данных (в
              рамках подготовки, заключения, исполнения и прекращения договоров
              с Оператором).
              <br /> 7.6. Оператор обязуется не принимать на основании
              исключительно автоматизированной обработки персональных данных
              решений, порождающих юридические последствия в отношении субъекта
              персональных данных или иным образом затрагивающих его права и
              законные интересы, за исключением случаев, предусмотренных
              действующим законодательством Российской Федерации в области
              персональных данных, и только при выполнении всех необходимых
              требований и условий.
              <br /> 7.7. Выражая согласие на обработку своих персональных
              данных, Пользователь соглашается с тем, что с момента
              информирования Оператора о решении заключить договор с Оператором
              доступ к персональным данным может быть предоставлен организациям,
              входящим в группу компаний «СИГНАЛ-КОМ», исключительно в целях
              подготовки, заключения, исполнения и прекращения договоров с
              Оператором.
              <br /> 7.8. Выражая согласие на обработку своих персональных
              данных, Пользователь соглашается с тем, что в случае необходимости
              предоставления персональных данных третьим лицам — агентам
              Оператора в целях подготовки, заключения, исполнения и прекращения
              договоров с Оператором, Пользователь соглашается также на передачу
              своих персональных данных агентам, при этом Оператор гарантирует,
              что агенты осуществляют обработку и защиту персональных данных на
              условиях, аналогичных изложенным в настоящей Политике. Перечень
              агентов Оператора приведен на сайте <a href="https://smarttoken.pro" target="_blank" > https://smarttoken.pro</a>.
              <br /> 7.9. Условиями прекращения обработки персональных данных
              являются:
              <br /> — прекращение деятельности Оператора;
              <br /> — достижение целей обработки персональных данных;
              <br /> — истечение срока действия согласия Пользователя;
              <br /> — отзыв согласия Пользователя;
              <br /> — выявление неправомерной обработки персональных данных.
            </p>
            <strong> 8. Сроки хранения и обработки персональных данных</strong>
            <p>
              8.1. Срок хранения и обработки персональных данных составляет не
              более 30 (тридцати) календарных дней, если Пользователь за этот
              срок не проинформировал Оператора о своём намерении заключить
              договор в рамках осуществления деятельности Оператора. В ином
              случае обработка персональных данных действует до момента
              ликвидации Оператора в соответствии с требованиями
              законодательства Российской Федерации в сфере деятельности
              Оператора.
            </p>
            <strong>9. Обеспечение безопасности персональных данных</strong>
            <p>
              9.1. Безопасность персональных данных обеспечивается Оператором
              путем реализации правовых, организационных и технических мер,
              необходимых и достаточных для обеспечения требований федерального
              законодательства в области защиты персональных данных и защиты их
              от несанкционированного доступа, уничтожения, изменения,
              блокирования и других несанкционированных действий.
              <br /> 9.2. Для целенаправленного создания неблагоприятных условий
              и труднопреодолимых препятствий для нарушителей, пытающихся
              осуществить несанкционированный доступ к персональным данным,
              Оператором в полном объёме применяются организационно-технические
              меры в соответствии со ст. 18, ст. 19 Федерального закона от
              27.07.2006 № 152-ФЗ «О персональных данных», в том числе
              Оператором:
              <br />— назначен ответственный за организацию обработки
              персональных данных;
              <br /> — утверждены документы, определяющие политику Оператора в
              отношении обработки персональных данных, локальные акты по
              вопросам обработки персональных данных и по вопросам
              предотвращения, выявления и устранения последствий нарушений
              законодательства Российской Федерации;
              <br /> — осуществляется внутренний контроль соответствия обработки
              персональных данных Федеральному закону от 27.07.2006 № 152-ФЗ «О
              персональных данных» и принятым нормативным правовым актам,
              требованиям к защите персональных данных, локальным актам
              Оператора;
              <br /> — работники Оператора, непосредственно осуществляющие
              обработку персональных данных, ознакомлены с положениями
              законодательства Российской Федерации о персональных данных, в том
              числе требованиями к защите персональных данных, локальными актами
              по вопросам обработки персональных данных и умеют применять их на
              практике;
              <br /> — иные меры, предусмотренные законодательством Российской
              Федерации и исполнительными органами государственной власти в
              области обработки и обеспечения безопасности персональных данных.
              <br /> 9.3. Обработка персональных данных, осуществляемая без
              использования средств автоматизации, осуществляется в соответствии
              с требованиями законодательства Российской Федерации о
              персональных данных, выполняемыми в полном объёме.
            </p>
            <strong> 10. Использование файлов cookie</strong>
            <p>
              10.1. Посещая сайты Оператора, Пользователь дает согласие
              Оператору на обработку файлов cookie с использованием метрических
              сервисов Google Analytics (Гугл Аналитикс), Google Adwords (Гугл
              Адвордс), Yandex Metrika (Яндекс Метрика), Yandex.Direct
              (Яндекс.Директ) для анализа использования, измерения и повышение
              уровня производительности сайтов Оператора.
              <br />
              10.2. Обработка файлов cookie Оператором осуществляется в
              обобщенном виде и никогда не соотносится с личными сведениями
              Пользователей.
              <br />
              10.3. Настоящее согласие действует с момента его предоставления и
              в течение всего периода использования сайта Пользователем.
              <br /> 10.4. В случае отказа от обработки файлов cookie
              Пользователю необходимо прекратить использование сайта Оператора
              или отключить использование файлов cookie в настройках браузера,
              при этом некоторые функции сайта Оператора могут стать недоступны.
            </p>
            <strong>
              {" "}
              11. Особенности обработки персональных данных на сайтах агентов
              Оператора
            </strong>
            <p>
              11.1. Агенты Оператора могут использовать собственные сайты для
              обработки следующих персональных данных Пользователей с целями
              4.1.1, 4.1.2 и 4.1.4 на основании поручения Оператора в
              соответствии со ст. 6 Федерального закона от 27.07.2006 № 152-ФЗ
              «О персональных данных»:
              <br /> — фамилия, имя, отчество;
              <br /> — ИНН;
              <br />— адрес места жительства;
              <br />— контактный телефон;
              <br /> — адрес электронной почты.
              <br />
              11.2. Сайты агентов Оператора могут обрабатывать файлы cookie на
              условиях, аналогичных разделу 10 настоящей Политики.
              <br /> 11.3. Электронные формы сайтов агентов Оператора,
              предназначенные для ввода персональных данных и используемые для
              обработки персональных данных по поручению Оператора, должны иметь
              поле для выражения Пользователем согласия на обработку
              персональных данных:
              <br /> ☐ Я даю согласие АО «СИГНАЛ-КОМ» на обработку своих
              персональных данных в соответствии с Политикой.
              <br /> 11.4. Электронные формы сайтов агентов Оператора, указанные
              в п. 11.3, должны иметь следующий текст уведомления Пользователя о
              правовом статусе агента:
              <br />
              %Наименование агента% является агентом АО «СИГНАЛ-КОМ».
              <br />
              11.5. Пользователь выражает Оператору согласие на обработку своих
              персональных данных и соглашается с тем, что персональные данные
              подлежат передаче агенту Оператора, на сайте которого Пользователь
              выразил согласие. При этом на правила обработки таких персональных
              данных распространяются все положения настоящей Политики.
            </p>
            <strong>
              12. Актуализация, исправление, удаление и уничтожение персональных
              данных, ответы на запросы субъектов на доступ к персональным
              данным
            </strong>
            <p>
              {" "}
              12.1. В случае подтверждения факта неточности персональных данных
              или неправомерности их обработки, персональные данные подлежат их
              актуализации Оператором, а обработка должна быть прекращена,
              соответственно.
              <br />
              12.2. Оператор обязуется уничтожать персональные данные при
              достижении целей обработки персональных данных, а также в случае
              отзыва Пользователем согласия на их обработку, если:
              <br /> — иное не предусмотрено договором, стороной которого,
              выгодоприобретателем или поручителем, по которому является
              Пользователь;
              <br /> — Оператор не вправе осуществлять обработку без согласия
              Пользователя на основаниях, предусмотренных Федеральным законом от
              27.07.2006 № 152-ФЗ «О персональных данных» или иными федеральными
              законами;
              <br /> — иное не предусмотрено иным соглашением между Оператором и
              Пользователем.
              <br /> 12.3. Оператор обязуется сообщать Пользователю или его
              представителю информацию об осуществляемой им обработке
              персональных данных такого Пользователя по запросу.
              <br /> 12.4. Обработка запросов Пользователей и их законных
              представителей, а также уполномоченных органов осуществляется
              Оператором в порядке, установленном Федеральным законом от
              27.07.2006 № 152-ФЗ «О персональных данных».
              <br />
              12.5. Почтовый адрес Оператора для приема письменных запросов:
              115193, Москва, а/я №6.
              <br />
              12.6. Рекомендуемая форма письменного запроса приведена в
              Приложении 1 к Политике.
              <br />
              12.7. Адреса для личного приема Пользователей размещены на сайте
              Оператора в сети интернет: <a href="https://smarttoken.pro" target="_blank" > https://smarttoken.pro</a>.
            </p>
            <strong>13. Заключительные положения</strong>
            <p>
              13.1. Оператор имеет право вносить изменения в настоящую Политику
              в одностороннем порядке в случае изменения нормативных правовых
              актов Российской Федерации, а также по своему усмотрению.
              <br />
              13.2. Настоящая Политика вступает в силу с момента ее
              опубликования на сайте Оператора <a href="https://smarttoken.pro" target="_blank" > https://smarttoken.pro</a> и
              распространяется на персональные данные Пользователя, полученные
              как до, так и после вступления в силу настоящей Политики.
              <br /> 13.3. Лица, виновные в нарушении норм обработки и защиты
              персональных данных несут ответственность, предусмотренную
              законодательством Российской Федерации, локальными актами
              Оператора и договорами, регламентирующими правоотношения Оператора
              с третьими лицами.
            </p>
            <strong>14. Реквизиты Оператора</strong>
            <p>
              <br /> Акционерное общество «СИГНАЛ-КОМ» (АО «СИГНАЛ-КОМ»)
              <br />
              Юридический адрес: 115088, г. Москва, набережная Крутицкая, дом
              23, квартира 64.
              <br /> Почтовый адрес: 115193, Москва, а/я №6.
              <br /> Адрес для направления курьера: 115088, Москва, Угрешская
              ул., дом 2, строение 15.
              <br /> ОГРН: 1027700239863
              <br /> ИНН: 7714028893
              <br />
              КПП: 772501001
              <br />
              Тел: +7 (495) 663-3073, 663-3034, 663-3093
              <br />
              e-mail: signal@signal-com.ru
            </p>
            <p className="d-flex justify-content-end">
              <strong>Приложение</strong>
            </p>
            <br />
            <br />
            <p className="d-flex justify-content-center">
              <strong>
                Образец формы письменного запроса на получение информации,
                касающейся обработки персональных данных
              </strong>
            </p>
            <p className="d-flex justify-content-end">
              <br /> Оператору персональных данных АО «СИГНАЛ-КОМ»
              <br />
              115088, г. Москва, набережная Крутицкая, дом 23, квартира 64
              <br />
              от:
              <br />
              адрес регистрации:
              <br />
              паспорт: серия _ _ _ _ № _ _ _ _ _ _
              <br />
              выдан:___________________________
              <br />
              дата выдачи:_ _._ _._ _ _ _
              <br /> сведения, подтверждающие факт обработки персональных данных
              Оператором:
              <br />
              _______________________________________________________
              <br />
              Почтовый адрес для направления ответа Оператора:
              <br />
              _______________________________________________________
            </p>
            <p>
              <strong>
                Запрос на получение информации, касающейся обработки
                персональных данных
              </strong>
              <br />В соответствии со ст. 14 Федерального закона от 27.07.2006 №
              152-ФЗ «О персональных данных», прошу предоставить сведения,
              касающиеся обработки моих персональных данных, а именно (нужное
              выбрать):
              <br />☐ Подтверждение факта обработки моих персональных данных.
              <br /> ☐ Правовые основания и цели обработки моих персональных
              данных.
              <br />☐ Цели и применяемые Оператором способы обработки моих
              персональных данных
              <br />☐ Сведения о лицах (за исключением работников Оператора),
              которые имеют доступ к моим персональным данным или которым могут
              быть раскрыты мои персональные данные на основании договора с
              Оператором или на основании федерального закона.
              <br />☐ Перечень обрабатываемых персональных данных и источник их
              получения.
              <br />☐ Сроки обработки моих персональных данных, в том числе
              сроки их хранения.
              <br />☐ Порядок осуществления субъектом персональных данных прав,
              предусмотренных Федеральным законом от 27.07.2006 № 152-ФЗ «О
              персональных данных».
              <br />☐ Информация об осуществленной или о предполагаемой
              трансграничной передаче данных.
              <br />☐ Наименование или фамилию, имя, отчество и адрес лица,
              осуществляющего обработку моих персональных данных по поручению
              оператора.
              <br />
              <span className="d-block d-md-none">
                ☐ Иные сведения, предусмотренные федеральным законодательством
                Российской Федерации.
                (указать)______________________________________________.
              </span>
              <span className="d-none d-md-block">
                ☐ Иные сведения, предусмотренные федеральным законодательством
                Российской Федерации. (указать)
                ______________________________________________________________________.
              </span>
            </p>
            <p className="d-flex justify-content-end mb-0 d-none d-md-bkcok">
              ☐ Иные сведения, предусмотренные федеральным законодательством
              Российской Федерации. (указать)_________________ _________________
              _________________
            </p>
            <p className="d-flex justify-content-end mb-0 d-block d-md-none">
              ☐ Иные сведения, предусмотренные федеральным законодательством
              Российской Федерации. (указать)
              <br />
              __________________ __________________ _________________
            </p>
            <p className="d-flex justify-content-end">
              {" "}
              (Ф.И.О.) (подпись) (дата)
            </p>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
